import { render, staticRenderFns } from "./BlogPostImage.vue?vue&type=template&id=5b8819ef"
import script from "./BlogPostImage.vue?vue&type=script&lang=js"
export * from "./BlogPostImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports